import { useState } from "react";

export default function Step1({
  dateOption,
  msg,
  nameTour,
  nameDate,
  onSelectTour,
  onSelectDate,
  onClickClose,
  register,
  tourOption,
  title,
  tourType,
  onSelectTourTypeJoin,
  onSelectTourTypePrivate,
}) {
  const active = { backgroundColor: "var(--primary)", color: "#fff" };
  const inactive = { backgroundColor: "#fff", color: "var(--primary)" };
  return (
    <div className="step_selection">
      <div className="title_step_selection">{title}</div>
      <div className="step_indicator">
        <div className="point">
          <div className="pass">1</div>
          <p>{msg.select_tour_and_date}</p>
        </div>
        <span className="" />
        <div className="">
          <div className="pass">2</div>
          <p>{msg.select_boat}</p>
        </div>
      </div>
      <div className="select-join-private">
        <button
          style={tourType?.toLowerCase() === "join" ? active : inactive}
          onClick={onSelectTourTypeJoin}
        >
          {msg.join}
        </button>
        <button
          style={tourType?.toLowerCase() === "private" ? active : inactive}
          onClick={onSelectTourTypePrivate}
        >
          {msg.private}
        </button>
      </div>
      <div className="container_step_1">
        <div className="_input_text_select">
          <label>{`${msg.select_tour} *`}</label>
          <select
            {...register(nameTour, { required: true, onChange: onSelectTour })}
          >
            <option value="" label={msg.select_tour} />
            {tourOption.map((el, index) => (
              <option key={index} value={el.value} label={el.label} />
            ))}
          </select>
        </div>
        <div className="_input_text_select">
          <label>{`${msg.select_date} *`}</label>
          <select
            {...register(nameDate, { required: true, onChange: onSelectDate })}
          >
            <option value="" label={msg.select_date} />
            {dateOption.map((el, index) => (
              <option key={index} value={el.value} label={el.label} />
            ))}
          </select>
        </div>
      </div>
      <div className="footer_button">
        <span className="left"></span>
        <span className="right">
          {onClickClose && <button onClick={onClickClose}>{msg.close}</button>}
        </span>
      </div>
    </div>
  );
}
